// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","sidebarToggle":"SidebarToggle_sidebarToggle__3S0iF"};